<template>
  <heading
    :modifiers="['v2-overflow']"
    background="banner-bag"
    class="stores-page__header overflow-visible pb-0 items-start">
    <template #title>
      Nos points relais
    </template>
  </heading>

  <div class="bg-beryl-green">
    <potager-container>
      <div
        class="flex relative bg-bianca rounded-xl overflow-hidden max-h-[85vh] h-[800px] bp840:h-[650px] bp640:h-[550px] shadow-2xl">
        <router-view
          :back-route="backRoute"
          :context="context"
          :home-route="homeRoute"
          class="w-[425px] min-w-[425px] bp768:min-w-full z-10"
          @onDlpSelect="onDlpSelect"
          @onGddSubmit="onGddSubmit"
          @onHomeDeliveryRedirect="onHomeDeliveryRedirect" />

        <dlp-map-public
          v-if="!$potagerRoute?.meta?.isPanel"
          :context="context"
          class="delivery-points-page__map"
          @onDlpSelect="onDlpSelect" />
      </div>
    </potager-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import PotagerContainer from 'UI/PotagerContainer';

import DlpMapPublic from 'Components/deliveryPoint/map/DlpMapPublic';
import Heading from 'Components/heading/Heading';

import MetaInfosService from 'Classes/services/MetaInfoService';
import { getDlpUpdateRoute, getDlpSearchRoute } from 'Classes/utils/DlpRouteUtils';
import { DELIVERY_HOME_TYPE } from 'Classes/workflow/TunnelTypesConstants';

import { Context } from 'PotagerLogic/Enums/Context';

export default {
  components: {
    DlpMapPublic,
    Heading,
    PotagerContainer,
  },

  computed: {
    ...mapGetters('tunnel', [
      'getStepRouteByName',
    ]),
    ...mapGetters('session', [
      'isLoggedIn',
    ]),
    ...mapGetters('user', [
      'isSubscriptionActive',
    ]),
    backRoute() {
      return this.$route.name === 'delivery-points' ? undefined : { name: 'delivery-points' };
    },
    homeRoute() {
      return getDlpSearchRoute({
        context: Context.Basket,
        type: DELIVERY_HOME_TYPE,
        currentRoute: this.$potagerRoute,
      });
    },
    context() {
      const ctx = this.$route?.params?.context || this.$route?.query?.context;
      if (ctx) return ctx;
      return (this.isLoggedIn && this.isSubscriptionActive) ? Context.Basket : Context.SubscriptionBasket;
    },
  },

  methods: {
    onSearch() {
      if (this.$route.params.deliveryPointId) {
        this.$router.push({ name: 'delivery-points' });
      }
    },
    onDlpSelect(dlp) {
      if (dlp) {
        this.$router.push({
          name: 'delivery-point',
          params: {
            deliveryPointRegionId: dlp.regionId,
            deliveryPointId: dlp.id,
          },
        });
      } else {
        this.onSearch();
      }
    },
    onGddSubmit({
      dlpId,
      gddId
    }) {
      this.$notify({
        type: 'success',
        title: 'Choix de livraison enregistrés',
        text: 'Vous pouvez commander et faire votre marché !',
      });

      if (this.isLoggedIn && this.isSubscriptionActive) {
        this.$router.push(getDlpUpdateRoute({
          dlpId,
          gddId,
          currentRoute: this.$potagerRoute,
        }));
      } else {
        this.$router.push(this.getStepRouteByName('boxSlider'));
      }
    },
    onHomeDeliveryRedirect(regionId) {
      this.$router.push(this.getStepRouteByName('deliveryPointHomeSearch', {
        params: { regionId },
      }));
    },
  },

  head() {
    return MetaInfosService.generate({
      title: 'Nos Points Relais',
      description: 'Profitez de paniers de fruits et légumes frais tout au long de l\'année avec nos points de relais Potager City. Commandez dès aujourd\'hui !',
    }, this.$route);
  },
};
</script>
